import DataGrid, { FilterRow, Grouping, GroupItem, GroupPanel, Pager, Paging, Summary } from 'devextreme-react/data-grid';
import React from 'react';
import useFormatMessage from '../../../utils/useFormatMessage';
const DatagridCustom = (OBJ) => {
    const { t } = useFormatMessage();
    const pageSizes = [10, 25, 50, 100, 200];

    const operationDescriptions = {
        "between": t("between"),
        "contains": t("contains"),
        "endswith": t("endswith"),
        "equal": t("equal"),
        "greaterThan": t("greaterThan"),
        "greaterThanOrEqual": t("greaterThanOrEqual"),
        "lessThan": t("lessThan"),
        "lessThanOrEqual": t("lessThanOrEqual"),
        "notContains": t("notContains"),
        "notEqual": t("notEqual"),
        "startswith": t("startswith"),
        "endsWith": t("endsWith")
    };


    return (
        <>
            <DataGrid
                id='gridContainer-custom'
                showBorders={true}
                showRowLines={true}
                showColumnLines={true}
                className='datagrid-color'
                style={{
                    minHeight: "400px",
                    maxHeight: "70vh"
                }}
                {...OBJ}
                allowColumnResizing={true}
                ref={OBJ.reff}
                noDataText={t("No Data")}
                columnAutoWidth={true}
                rowAlternationEnabled={true}
            // dataSource={
            //     new DataSource({
            //         store: OBJ.dataSource,
            //         langParams: {
            //             locale: 'tr',
            //             collatorOptions: {
            //                 sensitivity: 'accent',
            //                 caseFirst: 'upper'
            //             }
            //         }
            //     })
            // }

            >
                {
                    OBJ.groupPanel !== false &&
                    <GroupPanel visible={true}
                        emptyPanelText={t("Gruplamak için sütun başlığını buraya sürükleyin")}
                        allowColumnDragging={true}
                        showWhenGrouped={true}
                        texts={{
                            groupByThisColumn: t("Bu sütuna göre grupla"),
                            groupContinuedMessage: t("Devamı için buraya tıklayın"),
                            groupContinuesMessage: t("Devamı için buraya tıklayın"),
                            ungroup: t("Grubu çöz"),
                            ungroupAll: t("Tüm grupları çöz"),
                            ungroupRow: t("Grubu çöz"),
                            groupBy: t("Bu sütuna göre grupla")


                        }}

                    />}
                {OBJ.groupPanel !== false && <Grouping autoExpandAll={true} />}

                <FilterRow visible={true}
                    showAllText={t("tümü")}
                    operationDescriptions={operationDescriptions}
                    applyFilterText={t('Filtrele')}

                />
                <Pager enabled={true} allowedPageSizes={pageSizes} showPageSizeSelector={true} />
                <Paging defaultPageSize={25} />
                {/* <Scrolling mode="virtual" /> */}

                {OBJ.children}
                <Summary>

                    <GroupItem
                        column={Array.isArray(OBJ.children) ? OBJ.children[0]?.props?.dataField : ""}
                        summaryType="count"
                        displayFormat={"{0}"}

                    />
                </Summary>
            </DataGrid>
        </>
    )
}

export default DatagridCustom